import gql from 'graphql-tag';
import { postGQLFields } from './posts.fields.js';
export function getMemberPostsGQLQuery(fields) {
    return gql `
    query getMemberPost(
      $after: String
      $before: String
      $hasParent: Boolean
      $limit: Int!
      $memberId: ID!
      $offset: Int
      $reverse: Boolean
    ) {
      memberPosts(
        after: $after
        before: $before
        hasParent: $hasParent
        limit: $limit
        memberId: $memberId
        offset: $offset
        reverse: $reverse
      ) {
        edges {
          cursor
          node {
            ${postGQLFields(fields)}
          }
        }
        nodes {
          ${postGQLFields(fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  `;
}
//# sourceMappingURL=memberPosts.gql.js.map